import { render, staticRenderFns } from "./SiteMessageBanner.vue?vue&type=template&id=20143b80&scoped=true&lang=pug"
import script from "./SiteMessageBanner.vue?vue&type=script&lang=js"
export * from "./SiteMessageBanner.vue?vue&type=script&lang=js"
import style0 from "./SiteMessageBanner.vue?vue&type=style&index=0&id=20143b80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20143b80",
  null
  
)

export default component.exports